import { str } from './str.js'
export const DOM = (function() {
    window.DOM = this
    /**
     * Find or create element with given id or tag with getElementById or createElement
     * attr can be passed as attributes object or HTMLElement to append or as boolean to guard for checking existing element
     * @param {string} tag
     * @param {object|boolean|HTMLElement} attr
     * @param {HTMLElement|string} append
     * @returns {HTMLElement}
     */
     function element(tag, attr, append){
        let element = typeof tag === 'string' ? document.getElementById(tag) : null
        if(typeof attr === 'boolean')
            if(!element && !attr) // attr must be false if element not exists
                return attr // guard if element not exists
        if(this.isElement(tag)) // tag is HTMLElement
            element = tag
        if(!element && typeof tag === 'string') // tag is string
            element = document.createElement(tag) // create new element

        if(typeof attr === 'object' && !this.isElement(attr)) // set attributes from attr object
           element = setAttributes(element,attr)

        if(typeof attr === 'function')
            attr(element)
        if(this.isElement(attr))
            append = attr

        if(isElement(append))
            element.append(append)
        if(typeof append === 'string'){
            if(str.isHTML(append))
                element.innerHTML = append
            else
                element.textContent = append
        }
        if(typeof append === 'function')
            element.addEventListener('click',append)
        if(Array.isArray(append))
            append.forEach( item => element.append(item))
        return element
    }
    element.prototype.element = function(attr, append) {
        return element(this,attr,append)
    }
    /**
     * Sets attributes on given element and/or sets addEventListener if function property is passed and given property is a valid event
     * @example setAttributes(ui.element('a'),{ href : '#' ,click(event) {
     *     console.log(event) // link is clicked / event log
     * }})
     * @param {HTMLElement} _element
     * @param {object} attr
     * @returns {HTMLElement}
     */
    function setAttributes(_element,attr){
        Object.keys(attr).forEach((key)=>{
            if(key === 'textContent' || key === 'innerHTML')  {
                _element[key] = attr[key]
            } else if(typeof attr[key] === 'function'){
                //console.log(key,_element)
                if(getEvents(_element).includes(key))
                    _element.addEventListener(key,attr[key])
            } else if(typeof attr[key] === 'string'){
                _element.setAttribute(key,attr[key])
            }

        })
        return _element
    }
    element.prototype.attr = function(attr) {
        setAttributes(this,attr)
    }

    element.prototype.$ = function(){
        if(!jQuery) return this
        return $(this)
    }

    /**
     * Checks if object is HTMLElement
     * @param {*} obj
     * @returns {boolean}
     */
    function isElement(obj) {
        try {
          return obj instanceof HTMLElement
        }
        catch(e){
          return (typeof obj==="object") &&
            (obj.nodeType===1) && (typeof obj.style === "object") &&
            (typeof obj.ownerDocument ==="object")
        }
    }

    function isjQuery(obj){
        const jQuery = window.jQuery
        try{
            return obj instanceof jQuery
        }
        catch(e){

        }
    }
    function getEvents(obj){
        const events = []
        for(let prop in obj)
            if(prop.includes('on'))
                events.push(prop.substring(2))
        return events
    }
    /**
     * Reurns element with querySelector or querySelectorAll with : prefix
     * @param {*} selector
     * @param {*} parent
     * @returns {HTMLElement|HTMLCollection}
     */
    function select(selector,parent = {}) {
        let element,attr,callback

        if(typeof parent === 'string')
            parent = this(parent)
        if(typeof parent === 'object' && !isElement(parent)){
            attr = parent
            parent = document
        }
        if(!parent)
            parent = document

        if(typeof parent === 'function'){
            callback = parent
            parent = document
        }
        if(selector.startsWith(':')){
            if(!selector.split(':')[0] === '')
                element = parent.querySelector(selector.split(':')[0]).querySelectorAll(selector.split(':')[1])
            else
                element = parent.querySelectorAll(selector.split(':')[1])
        } else {
            element = parent.querySelector(selector)
        }
        if(attr){
            if(NodeList.prototype.isPrototypeOf(element)){
                element.forEach(_element => {
                    _element = setAttributes(_element,attr)
                })
            }else{
                element = setAttributes(element,attr)
            }
        }
        if(callback){
            if(NodeList.prototype.isPrototypeOf(element)){
                element.forEach(_element => {
                    callback(_element)
                })
            }else{
                callback(element)
            }
        }
        return element
    }

    select.prototype.select = function(selector,parent = this) {
        return select(selector,parent)
    }

    select.prototype.attr = function(attr) {
        return setAttributes(this, attr)
    }

    function selectAll(selector) {
        return select(`:${selector}`)
    }
    /**
     * Returns Document Fragment
     * @param {Array} contents
     * @returns {DocumentFragment}
     */
    function fragment(contents){
        const fragment = new DocumentFragment
        if(Array.isArray(contents)){
            contents.forEach(element => fragment.append(element))
        }
        return fragment
    }

    function parser(html){
        const parser = new DOMParser()
        return parser.parseFromString(html, 'text/html')
    }

    return {
        element,
        isElement,
        select,
        selectAll,
        fragment,
        parser
    }
})()
